import React from "react";
import { RocketLaunchIcon } from "@heroicons/react/24/outline";
function PromptTourPopup(props) {
  const { onClose, onContinue } = props;

  const handleClose = () => {
    if (typeof onClose === "function") {
      onClose();
    }
  };
  const handleContinue = () => {
    if (typeof onContinue === "function") {
      onContinue();
    }
  };
  return (
    // Your alert popup component JSX

    <div className="bg-white rounded-lg shadow lg:w-[480px] outline-none focus:rounded-lg focus:outline-none focus:ring-main-violate flex flex-col items-center justify-evenly h-[380px]">
      <RocketLaunchIcon
        width={"80px"}
        height={"80px"}
        className="text-green-1"
      />
      <div className="text px-2 px-2">
        <p className="font-bold text-center text-lg mb-4">Let&apos;s tour</p>
        <p className="text-center text-base">
          Do you want to take a tour to see the features of this application?
        </p>
      </div>

      <div className="flex mt-5 justify-center w-[100%]">
        <button
          className="border border-line-grey-1 text-grey-98 hover:border-2 cursor-pointer  w-[160px] px-4 py-2 text-[16px] leading-[22.4px] text-black border-line-grey-1 font-semibold tracking-normal h-[46px] rounded-lg mt-5 disabled:bg-violet-300 disabled:cursor-not-allowed mr-4"
          type="submit"
          onClick={handleClose}
        >
          Skip
        </button>
        <button
          className="hover:bg-violet-600 cursor-pointer bg-main-violate  w-[160px] px-4 py-2 text-[16px] leading-[22.4px] text-white font-semibold tracking-normal h-[46px] rounded-lg mt-5 disabled:bg-violet-300 disabled:cursor-not-allowed"
          type="submit"
          onClick={handleContinue}
        >
          Take a Tour
        </button>
      </div>
    </div>
  );
}

export default PromptTourPopup;
